import {
  useCartAttributes,
  useCartItemCount,
  useUpdateProductStepItem
} from "../cart/cart.mjs";
import { useAlerts } from "../alerts.mjs";
import { extractValue } from "../../utils/collections.mjs";
import { debounce } from "lodash-es";
import { computed, ref, watch } from "vue";
export function useQuantityControl(sku, max, min, stock, parentSku, options) {
  const { cartItemCount } = useCartItemCount(sku);
  const { items } = useCartAttributes();
  const { error } = useAlerts();
  const { updateCartQty } = useUpdateProductStepItem(sku, parentSku, options);
  const count = ref(cartItemCount.value);
  function resolveCountValue(value, min2) {
    const isIncrease = value > 0;
    const parsedValue = Number(Math.abs(value));
    if (isIncrease) {
      return parsedValue < min2 ? min2 : parsedValue;
    }
    return parsedValue < min2 ? 0 : parsedValue;
  }
  async function onCountChange(value) {
    const oldValue = count.value;
    try {
      count.value = resolveCountValue(value, extractValue(min));
      await updateCartQty(count.value);
    } catch (e) {
      console.log(e);
      if (/The requested sku is not assigned to given stock./.test(
        e?.message
      ))
        error("STOCK", "The requested sku is not assigned to given stock.");
      count.value = oldValue;
    }
  }
  const maxQuantity = computed(() => {
    return Math.min(extractValue(max), extractValue(stock));
  });
  watch(cartItemCount, (value) => {
    count.value = value;
  });
  const debouncedOnCountChange = debounce(onCountChange, 1e3);
  return {
    resolveCountValue,
    requestChangeCount: debouncedOnCountChange,
    count,
    items,
    maxQuantity
  };
}
